fx.ns("models", class Sticker extends fx.Media {

	constructor(data)
	{
        super(data);

        this.isBlob = true;
    }

    get defaults()
    {
        return { number: 0, number : 0, tags : [], keywords : "", id_lang : 1};
    }
    
    getUrl()
    {
        return (fx.get("quality") == "light")  ? this.light_url : this._url;
    }

    get uploadParams()
	{
		return {
            theme_category_id : this.theme_category_id,
            slug : this.slug, // provided in extractor as a prop
            width : this.width,
            height : this.height,
            visible : this.visible,
			mediatype : 'sticker',
            id_lang : this.id_lang
		};
    }

    get propertiesNotStorable()
    {
        return [ "id", "width", "height", "thumb", "url", "light_url"];
    }

    get localized()
    {
        return true;
    }

    get tags()
    {
        if (!this._tags)
            this._tags = [];

        return this._tags;
    }

    set tags(tags)
    {
        this._tags = tags;
    }


    get static()
    {
        return !this.movable && !this.resizable && !this.removable;
    }

    set static(val)
    {
        this.update({
                        movable : !val ? 1 : 0,
                        resizable : !val ? 1 : 0,
                        removable : !val ? 1 : 0
                    });
    }
    
    toggleShadow()
    {
        this.post({url : "/app/stickers/", action : "shadow", id : this.id, shadow : !this.shadow ? 1 : 0}, this._shadowUpdated);
    }
    
    _shadowUpdated(data)
    {
        if (!data.error)
            this.update({shadow : data.shadow, thumb : data.thumb});    
    }

    use(history)
    {
        //this.number = this.number + 1;
        this.update( {number :  this.number + 1}, {history : !!history} );				
    }

    unuse(history)
    {
        //this.number = Math.max(1, this.number - 1 );
        this.update( {number :  Math.max(0, this.number - 1)}, {history : !!history} );				
    }

    setVisible(val)
    {
        this.visible = val;

        if (val)
            this.available = 0;
    }


    loadLang(id_lang)
    {
        this.post({ url : "/app/stickers", action : "lang", id : this.id, id_lang : id_lang}, this._langLoaded)
    }

    _langLoaded(data)
    {
        if (data.error)
            this.event("load_lang_error");
        else
        {
            this.keywords = data.keywords;
            this.id_lang = data.id_lang;
            this.event("lang-loaded");
        }
    }


    getKeywords()
    {
        this.post("https://ai4.flexilivre.com/keywords", JSON.stringify({"image" : this.thumb, "image_type" : this.thumb.startsWith("https:") ? "url" : "base64", "lang" : "fr"}), this._getKeywords, {processData:false, contentType : 'application/json'});
    }

    _getKeywords(data)
    {
        if (data.keywords && data.keywords instanceof Array)
        {
            this.keywords = "";
            for(let i = 0; i < data.keywords.length; i++)
            {
                let keyword = data.keywords.getItemAt(i);
                this.keywords += keyword + (i < data.keywords.length - 1 ? " " : "");
            }
        }
    }
    
});
		